<template>
  <li>
    <router-link :to="{ name: 'graduates.single', params: { id: graduate.id }}">
      <div class="row">
        <div class="col d-flex align-items-center">
          <p>
            <span class="data-label d-xl-none">Graduate Name</span>
            {{ graduate.name }}
            <span class="d-block small">{{ graduate.email }}</span>
          </p>
        </div>

        <div class="col-auto d-flex align-items-center">
          <p class="text-muted">
            <span class="data-label d-xl-none">GEN</span> {{ graduate.gen }}
          </p>
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    graduate: {
      required: true,
      type: Object
    }
  }
}
</script>
